import { skyFoundationSettings } from '../configs/configs-service';

import { singletonClient } from './client';

const client = singletonClient.init(skyFoundationSettings.getPersonalizationApi());
const ERROR_TYPES = { graphql: 'graphql', generic: 'generic' };

export const isGraphQlError = (type) => type === ERROR_TYPES.graphql;
export const isGenericError = (type) => type === ERROR_TYPES.generic;

export const doQuery = async ({ query, variables, onStart, onSuccess, onFailure }) => {
  try {
    onStart?.();
    const response = await client.query(query, variables);
    if (response.errors) {
      onFailure?.(response.errors, ERROR_TYPES.graphql);
    } else {
      onSuccess?.(response.data);
    }
  } catch (error) {
    onFailure?.(error, ERROR_TYPES.generic);
  }
};

export const doMutation = async ({ mutation, variables, onStart, onSuccess, onFailure }) => {
  try {
    onStart?.();
    const response = await client.mutation(mutation, variables);
    if (response.errors) {
      onFailure?.(response.errors, ERROR_TYPES.graphql);
    } else {
      onSuccess?.(response.data);
      return response.data;
    }
  } catch (error) {
    onFailure?.(error, ERROR_TYPES.generic);
  }
};

export const doSubscription = ({ subscription, variables, onNext, onFailure }) => {
  const subscription$ = client.subscription(subscription, variables);
  subscription$.subscribe({
    next: (data) => onNext?.(data),
    error: (error) => onFailure?.(error),
  });
  return subscription$;
};
